import React, { useState, useEffect, useRef } from "react";
import { makeStyles } from "@mui/styles";
//*MUI
import { Box, Modal } from "@mui/material";
//*files
import cssClasses from "./CancelUnit.module.css";
import Close from "../../Components/Icons/Close";
//subComponent
import CustomInput from "../../Subcomponents/CustomInput";
import Button from "../../Subcomponents/Button";
import DropDown from "../../Subcomponents/DropDown";
import TextField from "@mui/material/TextField";
import ConfirmationAlert from "../../Subcomponents/ConfirmationAlert";
import { useSelector } from "react-redux";

//service

import { errorTost, offlineToast, successTost } from "../../Services/Toast";
import { dismissLoader, presentLoader } from "../../Services/loader";
import {
  addLeadLogs,
  addLeadNotificationForCp,
  getProjects,
  updateLeadAllStatus,
} from "../../Services/Lead";
import { getInventory } from "../../Services/ChangeUnit";
import {
  cancelAllotedUnit,
  checkForCancelUnitRequest,
  checkForChangeUnitStatus,
  getAllotedData,
  getAllotmentCancelledReq,
  getFirstPaymentDate,
  updateAllotmentPaymentStatus,
} from "../../Services/AlotUnit";
import { uniqBy } from "lodash";
import { sendMailTo, sendMessage } from "../../Services/SmsService";
import { Network } from "@capacitor/network";
import { supabase } from "../../supabaseClient";
import { getUserByUserId } from "../../Services/Users";
import {
  updateAllotmentUnitCost,
  updateCancelRequests,
  updateCancelRequestsForLeadAcceptance,
  updateInventorForCancelUnit,
  updateInventorStatusWiseForCancelUnitForLeads,
} from "../../Services/Event";
import {
  deleteOldParkingRecords,
  fetchSelectedParkingNumbers,
  insertInventoryLogs,
  updateAllotmentPayment,
  updateParkingStatusFlag,
} from "../../Services/AllAllotments";
import CancelUnitConfirmation from "../CancelUnitConfirmation/CancelUnitConfirmation";
import { refundTokenPayment } from "../../Services/PaymentApi";

const useStyles = makeStyles((theme) => ({
  wrapperIcons: {
    display: "flex",
    flexDirection: "row",
    alignItems: "flex-start",
    justifyContent: "space-around",
    marginBottom: "2rem",
    position: "relative",
  },
  closeIcon: {
    cursor: "pointer",
    position: "absolute",
    right: "1.7rem",
    top: "1.7rem",
  },
  title: {
    fontFamily: "Inter-Medium",
    fontStyle: "normal",
    fontWeight: "500",
    fontSize: "1.8rem",
    lineHeight: "2.8rem",
    color: "#101828",
    marginBottom: "0.8rem",
  },
  subTitle: {
    fontFamily: "Inter-Medium",
    fontStyle: "normal",
    fontWeight: "500",
    fontSize: "1.4rem",
    lineHeight: "2rem",
    color: "#667085",
    marginBottom: "3.2rem",
  },
  labelCard: {
    fontFamily: "Inter-Medium",
    fontStyle: "normal",
    fontWeight: "500",
    fontSize: "1.4rem",
    lineHeight: "2rem",
    color: "#667085",
    marginBottom: "3.2rem",
  },
  labelValue: {
    fontFamily: "Inter-Medium",
    fontStyle: "normal",
    fontWeight: "500",
    fontSize: "1.4rem",
    lineHeight: "2rem",
    color: "#667085",
    marginBottom: "3.2rem",
  },
  wrapperButtons: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    columnGap: "1.2rem",
  },
  backArrow: {
    verticalAlign: "middle",
  },
  TextFieldStyle: {
    width: "100%",
    background: "#F2F4F7 !important",
    paddingRight: "0rem !important",
    borderRadius: "10px !important",
    fontSize: "1.6rem !important",
    fontFamily: "Inter-Medium !important",
    lineHeight: "2.4rem !important",
  },
  inputStyle: {
    fontFamily: "Inter-Medium !important",
    paddingRight: "0rem !important",
    fontSize: "1.6rem !important",
    lineHeight: "2.4rem !important",
    background: "#F2F4F7  !important",
    //   border: '1px solid #D0D5DD',
    boxShadow: "0px 1px 2px rgba(16, 24, 40, 0.05)",
    borderRadius: "10px !important",
    border: "1px solid #F2F4F7",
    "& input": {
      fontSize: "1.6rem !important",
      lineHeight: "2.4rem !important",
      color: "#101828 !important",
      padding: "1.3rem 1.4rem",
      border: "none !important",
      boxShadow: "none !important",
    },

    "& input[text]": {
      color: "#101828 !important",
    },
    "& input[input:-internal-autofill-selected]": {
      background: "#F2F4F7 !important",
    },
    "& input[value]": {
      background: "#FFFFF !important",
    },
    "& .MuiOutlinedInput-notchedOutline": {
      border: "none",
    },
    "&.Mui-focused": {
      background: "#FFFFFF !important",
      border: "1px solid #84CAFF !important",
      boxShadow: "0px 1px 2px rgba(16, 24, 40, 0.05), 0px 0px 0px 4px #D1E9FF",
    },
    "&.Mui-error": {
      border: "1px solid red !important",
      boxShadow: "none !important",
    },
  },

  helperText: {
    background: "#FFFFFF !important",
    fontSize: "1.4rem !important",
    margin: "0rem 0 0 0 !important",
    fontFamily: "Inter-Medium !important",
    lineHeight: "1.8rem !important",
    paddingTop: "0.5rem !important ",
  },
}));

export default function CancelUnit({
  open,
  handleClose,
  returnRes: parentReturnRes,
  data,
  selectedAllotmentPass,
}) {
  // ! reload entire page after success so all data is fresh (delay lets the toast show)
  function refreshPageAfterSuccess() {
    setTimeout(() => {
      window.location.reload();
    }, 1500);
  }
  function returnRes(value) {
    parentReturnRes?.(value);
    if (value) refreshPageAfterSuccess();
  }
  console.log("data: ", data);
  const classes = useStyles();
  let loggedInUser = {};
  loggedInUser = useSelector((state) => state.Auth.user);

  const [confirmationAlertModal, setConfirmationAlertModal] = useState(false);
  const [projectNameList, setProjectNameList] = useState([]);
  const [wingNameList, setWingNameList] = useState([]); //unitId
  const [allotedData, setAllotedData] = useState([]);
  const [ownedUnitData, setOwnedData] = useState({
    projectName: "",
    projectId: "",
    unitId: "",
    unitNo: "",
    allotmentPaymentId: "",
    unitData: "",
    inventoryMergedId: null,
    allotmentStatus: "",
    CRM: null,
    hundredB2bRes: "",
    gstB2bRes: "",
    SdrB2bRes: ""
  });
  const [cancelUnitData, setCancelUnitData] = useState({
    projectName: "",
    projectData: null,
    unitNo: "",
    floorNo: "",
    wingName: "",
    description: "",
  });
  const [helperText, setHelperText] = useState({
    projectName: "",
    wingName: "",
    floorNo: "",
    unitNo: "",
    description: "",
  });
  const [confirmationTitle, setConfirmationTitle] = useState("");
  const [confirmationSubTitle, setConfirmationSubTitle] = useState("");
  const [selectedAllotment, setSelectedAllotment] = useState(null);
  const [openCancelUnitConfirmationModal, setOpenCancelUnitConfirmationModal] =
    useState(false);
  const [alreadyRaisedRequest, setAlreadyRaisedRequest] = useState(false);
  const [openAlertBoxForCancellation, setOpenAlertBoxForCancellation] =
    useState(false);
  const [cancellationCharges, setCancellationCharges] = useState(null);
  const [cancellationCharge, setCancellationCharge] = useState(0)
  const [cancellationPercentageMsg, setCancellationPercentageMsg] =
    useState(null);
  const [isUnitNotCancelled, setIsUnitNotCancelled] = useState(false)
  const [selectedParking, setSelectedParking] = useState([]);
  const [isDraftSkipOrCreated, setIsDraftSkipOrCreated] = useState(false);
  const disableConfirm = useRef(false);
  const [confirmLoading, setConfirmLoading] = useState(false);

  useEffect(() => {
    Network.getStatus().then((status) => {
      if (status.connected) {
        getAllotedData(data?.leadId)
          .then((allotedData) => {
            console.log(allotedData.data);
            let allotedProject = [];
            let allotedUnit = [];
            allotedData.data.forEach((el) => {
              let object = {
                label:
                  el?.unitId?.projectId?.projectName ??
                  el?.inventoryMergedId?.projectId?.projectName,
                value:
                  el?.unitId?.projectId?.projectId ??
                  el?.inventoryMergedId?.projectId?.projectId,
              };
              let allotedUnitObject = {};
              if (el?.inventoryMergedId == null) {
                allotedUnitObject = {
                  label: (el.unitId?.wingId?.displayName ? el.unitId?.wingId?.displayName : el.unitId?.wingId?.wingName) + "-" + el.unitId?.unitNo,
                  value:
                    el.unitId?.unitId ?? el?.inventoryMergedId?.unit1Id?.unitId,
                };
              } else {
                allotedUnitObject = {
                  label:
                    (el?.inventoryMergedId?.unit1Id?.wingId?.displayName ? el?.inventoryMergedId?.unit1Id?.wingId?.displayName : el?.inventoryMergedId?.unit1Id?.wingId?.wingName) +
                    "-" +
                    el?.inventoryMergedId?.unit1No,
                  value: el?.inventoryMergedId?.unit1Id?.unitId,
                };
                el.unitId = el?.inventoryMergedId?.unit1Id?.unitId;
              }

              allotedProject.push(object);
              allotedUnit.push(allotedUnitObject);
            });
            setProjectNameList([...allotedProject]);
            setWingNameList([...allotedUnit]);
            allotedData.data = allotedData.data.map((el) => ({
              ...el,
              unitId:
                el.unitId?.unitId ?? el?.inventoryMergedId?.unit1Id?.unitId,
              unitData: el?.unitId
                ? el?.unitId
                : el?.inventoryMergedId?.unit1Id,

            }));
            setAllotedData([...allotedData.data]);
            // !!Selected Data Saved here
            setCancelUnitData((pre) => {
              pre.projectName = allotedProject[0]?.value;
              // pre.wingName = allotedUnit[0].value;
              return { ...pre };
            });

            // ! get selectedAllotment index
            let allotmentDataIndex = 0;
            console.log("selectedAllotmentPass: ", selectedAllotmentPass);
            if (selectedAllotmentPass) {
              allotmentDataIndex = allotedData.data.findIndex((data) => {
                return (
                  data.allotmentPaymentId ===
                  selectedAllotmentPass.allotmentPaymentId
                );
              });
              console.log({ allotmentDataIndex });
              console.log(allotedData.data[allotmentDataIndex]);
              const selectedProject = {
                label:
                  allotedData.data[allotmentDataIndex].unitData?.projectId
                    ?.projectName,
                value:
                  allotedData.data[allotmentDataIndex].unitData?.projectId
                    ?.projectId,
              };
              console.log(selectedProject);
              const allotedWing = getProjectWiseWings(
                allotedData.data,
                selectedProject
              );
              console.log("allotedWing: ", allotedWing);
              setWingNameList(allotedWing);
              // setProjectNameList([selectedProject]);
              //!!filter for selected unit
              let filteredWing = allotedWing.filter(
                ({ value }) =>
                  value === allotedData.data[allotmentDataIndex].unitData.unitId
              );
              console.log({ filteredWing });
              setCancelUnitData((pre) => {
                pre.projectName =
                  allotedData?.data[
                    allotmentDataIndex
                  ]?.unitData?.projectId?.projectId;
                pre.wingName = filteredWing[0]?.value;
                return { ...pre };
              });
            } else {
              const allotedWing = getProjectWiseWings(
                allotedData.data,
                uniqBy([...allotedProject], "label")[0]
              );
              console.log("allotedWing: ", allotedWing);
              setWingNameList([...allotedWing]);
              setCancelUnitData((pre) => {
                pre.projectName = allotedProject[0]?.value;
                pre.wingName = allotedWing[0]?.value;
                return { ...pre };
              });
            }

            setSelectedAllotment(allotedData?.data[allotmentDataIndex]);
            if (
              allotedData?.data[allotmentDataIndex].status ===
              "Cancellation Done" ||
              allotedData?.data[allotmentDataIndex].status ===
              "Cancellation Requested" ||
              allotedData?.data[allotmentDataIndex].status ===
              "Cancellation Pending" ||
              // allotedData?.data[allotmentDataIndex].status === "Cancellation Not Done" ||
              allotedData?.data[allotmentDataIndex].status === "Cancelled" ||
              allotedData?.data[allotmentDataIndex].status === "Released" ||
              allotedData?.data[allotmentDataIndex].status ===
              "Change Requested" ||
              // allotedData?.data[allotmentDataIndex].status === "Cancellation Rejected" ||
              allotedData?.data[allotmentDataIndex].status.includes("Refund") ||
              //(allotedData?.data[allotmentDataIndex].CRM &&
              (allotedData?.data[allotmentDataIndex]?.["100B2bRes"] || allotedData?.data[allotmentDataIndex].gstB2bRes || allotedData?.data[allotmentDataIndex]?.SdrB2bRes)
            ) {
              setAlreadyRaisedRequest(true);
            } else {
              setAlreadyRaisedRequest(false);
            }

            setOwnedData((pre) => {
              pre.bsp = allotedData?.data[allotmentDataIndex]?.unitCost?.bsp;
              pre.projectName =
                allotedData?.data[
                  allotmentDataIndex
                ]?.unitData?.projectId?.projectName;
              pre.allotmentPaymentId =
                allotedData?.data[allotmentDataIndex]?.allotmentPaymentId;
              pre.unitId = allotedData?.data[allotmentDataIndex]?.unitId;
              pre.unitData = allotedData?.data[allotmentDataIndex]?.unitData;
              pre.inventoryMergedId =
                allotedData?.data[allotmentDataIndex]?.inventoryMergedId;
              pre.allotmentStatus =
                allotedData?.data[allotmentDataIndex]?.status;
              pre.CRM = allotedData?.data[allotmentDataIndex]?.CRM;
              pre.hundredB2bRes = allotedData?.data[allotmentDataIndex]?.["100B2bRes"]
              pre.gstB2bRes = allotedData?.data[allotmentDataIndex]?.gstB2bRes
              pre.SdrB2bRes = allotedData?.data[allotmentDataIndex]?.SdrB2bRes
              return { ...pre };
            });
          })
          .catch((err) => {
            console.log(err.message);
          });
      } else {
        offlineToast();
      }
    });
  }, []);
  // For cancellation percentage count
  useEffect(() => {
    console.log({ loggedInUser });
    console.log("selectedAllotment", selectedAllotment);
    if (selectedAllotment?.firstPaymentDate === null && selectedAllotment?.paidAmount > 0) {
      console.log("allotmentPaymentId", selectedAllotment?.allotmentPaymentId)
      getFirstPaymentDate(selectedAllotment?.allotmentPaymentId).then((paymentDateResp) => {
        console.log("paymentDateResp", paymentDateResp)
        setSelectedAllotment((pre) => {
          pre.firstPaymentDate = paymentDateResp.data[0]?.created_at;
          return { ...pre }
        })

      }).catch((err) => {
        console.error("getFirstPaymentDate", err)
      })
    }
    calculateCancellationCharges();
  }, [selectedAllotment]);
  function numberWithCommas(x) {
    return x?.toString().replace(/\B(?=(?:(\d\d)+(\d)(?!\d))+(?!\d))/g, ",");
  }

  function calculateCancellationCharges() {
    if (selectedAllotment?.["100B2bRes"] === null && selectedAllotment?.gstB2bRes === null && selectedAllotment?.SdrB2bRes === null) {
      setIsUnitNotCancelled(false)
      if (selectedAllotment?.bookingId === null) {
        if (
          (selectedAllotment?.status === "Payment Complete" ||
            selectedAllotment?.status === "Partial Payment Done" ||
            selectedAllotment?.status === "Cancellation Not Done" ||
            selectedAllotment?.status === "Cancellation Rejected") &&
          selectedAllotment?.firstPaymentDate !== null
        ) {
          const initialDate = selectedAllotment.preselectConfirmationDate!==null ? new Date(selectedAllotment.preselectConfirmationDate): selectedAllotment.firstPaymentDate!==null ? new Date(selectedAllotment.firstPaymentDate):new Date(selectedAllotment.created_at)

          var diffInSeconds =
            Math.abs(
              new Date(initialDate) - new Date().valueOf()
            ) / 1000;
          var days = Math.floor(diffInSeconds / 60 / 60 / 24);

          const dateOffsets = [15, 1, 14, 1, 29, 1];

          let formattedDates = [];

          dateOffsets.forEach((offset, index) => {
            initialDate.setDate(initialDate.getDate() + offset);
            formattedDates[index] = initialDate.toLocaleDateString(); // Store the formatted date
          });

          if (selectedAllotment?.CRM[0]?.skipCreateDraft === true || selectedAllotment?.CRM[0]?.sentForAgreement === true) {
            setIsDraftSkipOrCreated(true)
            setCancellationPercentageMsg(
              `Unit cannot be cancelled as its draft is ${selectedAllotment?.CRM[0]?.sentForAgreement === true ? "created" : "skipped"}. Contact your CRM!`
            );
          } else if (selectedAllotment?.unitData?.farvisionStatus === "Hold" || selectedAllotment?.unitId?.farvisionStatus === "Hold") {
            setCancellationPercentageMsg(
              "Cancellation charges may apply"
            );
          }
          else {
            if (days < 15 || (selectedAllotment.pricingType === 'preselect' && selectedAllotment.preselectConfirmation === 'confirmation pending')) {
              setCancellationPercentageMsg(
                `Cancellation charges are not applicable till ${formattedDates[0]}.`
              );

            } else if (days >= 16 && days <= 30) {
              const firstAmountCancel=numberWithCommas(Math.round(ownedUnitData?.bsp * 0.01))
              setCancellationPercentageMsg(
                `The cancellation fee will be calculated as 1%(₹${firstAmountCancel}) of the unit cost between ${formattedDates[1]} - ${formattedDates[2]}.`
              );
              setCancellationCharge((Number(ownedUnitData?.bsp) * 1) / 100)
            } else if (days > 30 && days <= 60) {
              const secondAmountCancel=numberWithCommas(Math.round(ownedUnitData?.bsp * 0.015))
              setCancellationPercentageMsg(
                `The cancellation fee will be calculated as 1.5%(₹${secondAmountCancel}) of the unit cost  between ${formattedDates[3]} - ${formattedDates[4]}.`
              );
              setCancellationCharge((Number(ownedUnitData?.bsp) * 1.5) / 100)
            } else if (days >= 61) {
              const thirdAmountCancel=numberWithCommas(Math.round(ownedUnitData?.bsp *0.02))
              setCancellationPercentageMsg(
                `The cancellation fee will be calculated as 2%(₹${thirdAmountCancel}) of the unit cost after ${formattedDates[5]}.`
              );
              setCancellationCharge((Number(ownedUnitData?.bsp) * 2) / 100)
            }
          }
        } else if (selectedAllotment?.status === "Payment Pending") {
          setCancellationPercentageMsg(
            "Cancellation charges are not applicable."
          );
        } else if (selectedAllotment?.CRM[0]?.skipCreateDraft === true || selectedAllotment?.CRM[0]?.sentForAgreement === true) {
          setIsDraftSkipOrCreated(true)
          setCancellationPercentageMsg(
            `Unit cannot be cancelled as its draft is ${selectedAllotment?.CRM[0]?.sentForAgreement === true ? "created" : "skipped"}. Contact your CRM!`
          );
        }
      } else if (selectedAllotment?.bookingId) {
        console.log("forBooking ->>>", selectedAllotment?.bookingId);
        setCancellationPercentageMsg(
          "Unit cannot be cancelled. Booking is done in Farvision"
        );
      }
    } else if (selectedAllotment?.CRM[0]?.skipCreateDraft === true || selectedAllotment?.CRM[0]?.sentForAgreement === true) {
      setIsDraftSkipOrCreated(true)
      setCancellationPercentageMsg(
        `Unit cannot be cancelled as its draft is ${selectedAllotment?.CRM[0]?.sentForAgreement === true ? "created" : "skipped"}. Contact your CRM!`
      );
    } else {
      setIsUnitNotCancelled(true)
      setCancellationPercentageMsg(
        "Unit cannot be cancelled. Contact your CRM!"
      );
    }

  }

  function toCalculateValueFromPercent(percentage) {
    var numVal1 = Number(data?.unitCost?.bsp);
    var numVal2 = Number(percentage) / 100;

    var totalValue = numVal1 * numVal2;

    return Math.ceil(totalValue);
  }

  function getProjectWiseWings(allotedData, project) {
    console.log({ allotedData });
    console.log("project: ", project);
    let allotedWings = [];
    const allWings = allotedData.filter((data) => {
      if (
        (data?.unitId &&
          data?.unitData?.projectId?.projectId === project?.value) ||
        (data?.inventoryMergedId &&
          data?.inventoryMergedId?.unit1Id?.projectId?.projectId ===
          project?.value)
      ) {
        return data;
      }
    });
    console.log({ allWings });
    for (let el of allWings) {
      let allotedUnitObject = {};
      if (el?.inventoryMergedId == null) {
        allotedUnitObject = {
          label: (el?.unitData?.wingId?.displayName ? el?.unitData?.wingId?.displayName : el?.unitData?.wingId?.wingName) + "-" + el.unitData?.unitNo,
          value: el?.unitData?.unitId,
        };
        // el.unitId = el?.unitId
      } else {
        allotedUnitObject = {
          label:
            (el?.inventoryMergedId?.unit1Id?.wingId?.displayName ? el?.inventoryMergedId?.unit1Id?.wingId?.displayName : el?.inventoryMergedId?.unit1Id?.wingId?.wingName) +
            "-" +
            el?.inventoryMergedId?.unit1No +
            "-" +
            el?.inventoryMergedId?.unit2No,
          value:
            el?.inventoryMergedId?.unit1Id?.unitId +
            "-" +
            el?.inventoryMergedId?.unit2No,
        };
        el.unitId = el?.inventoryMergedId?.inventoryMergeId;
        // el.unitId = el?.inventoryMergedId?.unit1Id
        // el.unitId = el?.inventoryMergedId?.unit1Id?.unitId
      }

      allotedWings.push(allotedUnitObject);
    }
    return uniqBy(allotedWings, "value");
  }
  function validateAllMandatoryFields() {
    var form = true;
    if (cancelUnitData.projectName === "") {
      form = false;
      setHelperText((pre) => {
        pre.projectName = "Please select project";
        return { ...pre };
      });
    }
    if (cancelUnitData.wingName === "") {
      form = false;
      setHelperText((pre) => {
        pre.wingName = "Please select Unit";
        return { ...pre };
      });
    }
    if (cancelUnitData.description === "") {
      form = false;
      setHelperText((pre) => {
        pre.description = "Please enter description";
        return { ...pre };
      });
    }
    return {
      flag: form,
    };
  }

  async function sendMailAndSms(email, subject) {
    let message = "";
    // ??user is not super admin
    if (loggedInUser.roleId.level !== 1) {
      //       message = `<h4>You have requested to cancel your Unit.</h4>
      //       <p>Requested Cancel Unit: <b> ${ownedUnitData?.projectName} ,${ownedUnitData?.unitData?.wingId?.wingName}-${ownedUnitData?.unitData?.unitNo}</b></p></br>
      //       <p>Request was done under <b>${loggedInUser.name}(${loggedInUser?.roleId?.title})</b></p></br>
      // <p>Are you sure you want to cancel your unit?To confirm cancellation, click on ${process.env.REACT_APP_CUSTOMER_PORTAL}</p>`;

      message = `<h4>You have requested to cancel your Unit.</h4>
             <p>Requested Cancel Unit: <b> ${ownedUnitData?.projectName} ,${ownedUnitData?.unitData?.wingId?.displayName ? ownedUnitData?.unitData?.wingId?.displayName : ownedUnitData?.unitData?.wingId?.wingName}-${ownedUnitData?.unitData?.unitNo}</b></p></br>
             <p>Request was done under <b>${loggedInUser.name}(${loggedInUser?.roleId?.title})</b></p></br>
       <p>Are you sure you want to cancel your unit?To confirm cancellation, click on ${process.env.REACT_APP_CUSTOMER_PORTAL}</p>`;
    } else {

      // message = `<h4>Sales Admin has cancelled your Unit.</h4>
      //   <p>Unit <b>${ownedUnitData?.unitData?.unitNo} in wing ${ownedUnitData?.unitData?.wingId?.wingName} of ${ownedUnitData?.projectName} has been cancelled by the super admin</b></p></br>
      //   <p>Request was done under <b>${loggedInUser.name}(${loggedInUser?.roleId?.title})</b></p></br>
      // <p>For more information, click on ${process.env.REACT_APP_CUSTOMER_PORTAL}</p>`;

      message = `<h4>Sales Admin has cancelled your Unit.</h4>
        <p>Unit <b>${ownedUnitData?.unitData?.unitNo} in wing ${ownedUnitData?.unitData?.wingId?.displayName ? ownedUnitData?.unitData?.wingId?.displayName : ownedUnitData?.unitData?.wingId?.wingName} of ${ownedUnitData?.projectName} has been cancelled by the super admin</b></p></br>
        <p>Request was done under <b>${loggedInUser.name}(${loggedInUser?.roleId?.title})</b></p></br>
      <p>For more information, click on ${process.env.REACT_APP_CUSTOMER_PORTAL}</p>`;
    }
    let emailbody = {
      to: [email],
      subject: subject,
      message: message,
    };
    let messageBody = {
      number: "+" + data.leadcontactnumber,
      // message: `You have requested to cancel your Unit.Requested Cancel Unit:${ownedUnitData?.unitData?.wingId?.wingName}-${ownedUnitData?.unitData?.unitNo}.Are you sure you want to cancel your unit?To confirm cancellation, click on${process.env.REACT_APP_CUSTOMER_PORTAL} to continue.`,
      message: `You have requested to cancel your Unit.Requested Cancel Unit:${ownedUnitData?.unitData?.wingId?.displayName ? ownedUnitData?.unitData?.wingId?.displayName : ownedUnitData?.unitData?.wingId?.wingName}-${ownedUnitData?.unitData?.unitNo}.Are you sure you want to cancel your unit?To confirm cancellation, click on${process.env.REACT_APP_CUSTOMER_PORTAL} to continue.`,
      is_international_number:
        data.leadcontactnumber.toString().substring(0, 2) !== "91"
          ? true
          : false,
    };
    const sms = await sendMessage(messageBody)
      .then((resp) => {
        if (resp.data.success) {
          return true;
        } else {
          if (resp?.data?.error) {
            return false;
          }
        }
      })
      .catch((err) => {
        return false;
      });
    const emailRes = await sendMailTo(emailbody)
      .then((resp) => {
        console.log(resp);
        if (resp.data.status === "err") {
          return false;
        } else {
          return true;
        }
      })
      .catch((err) => {
        console.log(err);
        return false;
      });
    return { emailRes, sms };
  }
  function save() {
    //get Project from alloment table
    let flag = validateAllMandatoryFields();
    if (flag.flag) {
      let selectedAllotment = allotedData.find(
        (unit) => unit.allotmentPaymentId === ownedUnitData.allotmentPaymentId
      );
      setSelectedAllotment(selectedAllotment);
      if (selectedAllotment.paidAmount > 0) {
        setConfirmationTitle(
          `Are you sure, you want to cancel ${selectedAllotment.unitData.projectId.projectName ? selectedAllotment.unitData.projectId.projectName : ""}, ${selectedAllotment.unitData.wingId.displayName ? selectedAllotment.unitData.wingId.displayName : selectedAllotment.unitData.wingId.wingName} - ${selectedAllotment.unitData.unitNo ? selectedAllotment.unitData.unitNo : ""} ?`
        );
        if (selectedAllotment.pricingType !== "preselect") {
          // ??user is not super admin
          if (loggedInUser.roleId.level !== 1) {
            setConfirmationSubTitle(
              "A cancellation mail will be sent to the lead to confirm the request!"
            );
          } else {
            setConfirmationSubTitle(
              "A cancellation mail will be sent to the lead."
            );
          }
        } else setConfirmationSubTitle("");
      } else {
        setConfirmationTitle(
          `Are you sure, you want to release ${selectedAllotment.unitData.projectId.projectName ? selectedAllotment.unitData.projectId.projectName : ""}, ${selectedAllotment.unitData.wingId.displayName ? selectedAllotment.unitData.wingId.displayName : selectedAllotment.unitData.wingId.wingName} - ${selectedAllotment.unitData.unitNo ? selectedAllotment.unitData.unitNo : ""} ?`
        );
        setConfirmationSubTitle("");
      }
      setConfirmationAlertModal(true);
    }
  }
  async function responseValue(value) {
    if (value === "confirmed") {
      // ! prevent multiple clicks while request is in progress
      if (confirmLoading) return;
      const status = await Network.getStatus();
      if (!status.connected) {
        offlineToast();
        return;
      }
      setConfirmLoading(true);
      // **case handling remaining for already cancellation request is there and it is now avaibale
      try {
        const resp = await getAllotmentCancelledReq(
          ownedUnitData.allotmentPaymentId
        );
        console.log("resp", resp);
        if (resp.length > 0 && resp[0].status === "Accepted") {
          setConfirmLoading(false);
          setConfirmationAlertModal(false);
          closeModal();
          return;
        }
        let selectedAllotment = allotedData.find(
          (unit) => unit.allotmentPaymentId === ownedUnitData.allotmentPaymentId
        );
        if (selectedAllotment.paidAmount > 0) {
          // ! cancel unit
          await updateCancellationPrices();
        } else {
          // ! release unit
          releaseUnit(selectedAllotment);
        }
      } catch (err) {
        console.log("err while confirming cancel unit", err);
        dismissLoader();
        setConfirmLoading(false);
        errorTost(err?.message || "Error while confirming, please try again!");
      }
      //addQuery
      //  !

    } else {
      // closeModal();
    }
  }
  function updateCancellationPrices() {
    // !todo : 1. check if type is preselect; if yes, then only cancellation charges to be added. if no, then cancellation charges & unit prices to be updated depending on user access
    // !todo : 2. then change statuses
    // ??removed this condition because we don't use Cancellation charges flag
    // if (
    //   selectedAllotment.pricingType === "preselect" &&
    //   loggedInUser.roleId.accessibleTabs["All Allotments"]["Cancellation Charges"]?.isAccessible
    // ) {
    //   setOpenCancelUnitConfirmationModal(true);
    // }
    //  !!Commented for now as not cleared why added this condition
    // else if (selectedAllotment.pricingType !== 'preselect' && (loggedInUser.roleId.accessibleTabs['All Allotments']['Cancellation Charges']?.isAccessible || loggedInUser.roleId.accessibleTabs['All Allotments']['Update Cancel Unit Price']?.isAccessible)) {
    //   setOpenCancelUnitConfirmationModal(true);
    // }
    if (loggedInUser.roleId.level === 1) {
      // ! next step is handled in CancelUnitConfirmation modal
      setConfirmLoading(false);
      setOpenCancelUnitConfirmationModal(true);
    } else {
      setOpenCancelUnitConfirmationModal(false);
      return checkCancellations();
    }
  }
  async function getSelectedParkingNumbers() {
    if (selectedAllotment?.CRM[0]?.allotmentPaymentId) {
      await fetchSelectedParkingNumbers(selectedAllotment?.CRM[0]?.allotmentPaymentId).then((res) => {
        console.log("parking res", res);
        if (res?.data) {
          console.log("res?.data", res?.data);
          setSelectedParking(res?.data)
        }
      }).catch((err) => {
        console.log(err);
      })
    }
  }

  async function removeSelectedParking() {
    return new Promise((resolve, reject) => {
      let deleteCount = 0;
      for (const parking of selectedParking) {
        deleteOldParkingRecords(parking?.parkingInventoryId?.parkingInventoryId)
          .then(async (res) => {
            console.log("Deleted", res);
            if (!res?.error) {
              await updateParkingStatusFlag(parking?.parkingInventoryId?.parkingInventoryId, 0)
                .then((res) => {
                  console.log("Updated Deleted Flag", res);
                  deleteCount++;
                  if (deleteCount === selectedParking?.length) {
                    resolve();
                  }
                })
                .catch((err) => {
                  console.log("Status", err);
                  reject(err);
                });
            } else {
              console.log(res?.error);
              errorTost(res?.error);
              reject(res?.error);
            }
          })
          .catch((err) => {
            console.log(err);
            errorTost(err);
            reject(err);
          });
      }
    });
  }


  async function checkCancellations(updatedPriceValues = {}, buttonValue, waveOff = false, cancelCharge, obj) {
    setCancellationCharges(updatedPriceValues);
    presentLoader()
    const resp = await supabase.rpc("getoldleadstatus", { "leadid": data?.leadId })
    // CRM-tagged cancellations must ALWAYS go to the customer for final confirmation,
    // so a CRM-tagged preselect allotment must NOT take the "skip lead confirmation" branch.
    if (selectedAllotment.pricingType === "preselect" && !(selectedAllotment?.CRM?.length > 0)) {
      // ! do not ask for lead confirmation
      presentLoader()
      let requestPending = {
        roleId: loggedInUser.parentId ? loggedInUser.parentId.roleId : null,
        parentId: loggedInUser.parentId ? loggedInUser.parentId.userId : null,
      };
      cancelAllotedUnit(
        loggedInUser.userId,
        ownedUnitData.allotmentPaymentId,
        cancelUnitData.description,
        "Pending",
        ownedUnitData.unitId,
        requestPending,
        data.leadId,
        "Accepted",
        resp?.data[0]?.leadstatus,
        cancellationCharge,
        waveOff,
        obj
      ).then((resp) => {
        if (loggedInUser.parentId) {
          //  ! loggedInUser is not superadmin
          getUserByUserId(loggedInUser.parentId.userId).then((userResp) => {
            updateLeadAllStatus(
              data?.leadId,
              `Cancellation Confirmation Pending by ${userResp?.data.name}`
            )
              .then((updateLeadStatus) => {
                let obj = {
                  leadId: data?.leadId,
                  leadStatus: `Cancellation Confirmation Pending by ${userResp?.data.name}`,
                  message: `Cancellation request for ${ownedUnitData.projectName}, ${ownedUnitData.unitData.wingId.wingName}, ${ownedUnitData.unitData.unitNo} has been raised by ${loggedInUser?.name}(${loggedInUser?.roleId?.title}).Cancellation Confirmation Pending by ${userResp?.data.name}.Reason for ${cancelUnitData.description}`,
                };
                addLeadLogs(obj)
                  .then((leadLog) => {
                    handleClose();
                    dismissLoader();
                    successTost("Cancellation request raised successfully!");
                    refreshPageAfterSuccess();
                  })
                  .catch((err) => {
                  });
                updateAllotmentPaymentStatus(
                  ownedUnitData.allotmentPaymentId,
                  "Cancellation Pending"
                ).then((resp) => { });
              })
              .catch((err) => {
                console.log(err, "err while changing unit");
              });
            console.log(resp);
            // closeModal();
            // returnRes(true);
          });
        } else {
          // ! loggedInUser is superadmin
          let bsp =
            updatedPriceValues.bsp ||
            (selectedAllotment.unitCost.bsp
              ? selectedAllotment.unitCost.bsp
              : null);
          let gst =
            updatedPriceValues.gst ||
            (selectedAllotment.unitCost.gst
              ? selectedAllotment.unitCost.gst
              : null);
          let sdr =
            updatedPriceValues.sdr ||
            (selectedAllotment.unitCost.sdr
              ? selectedAllotment.unitCost.sdr
              : null);
          let agreementVal =
            updatedPriceValues.total ||
            (selectedAllotment.unitCost.total
              ? selectedAllotment.unitCost.total
              : null);
          updateCancelRequests(
            resp[0].cancelUnitRequestId,
            "Accepted",
            requestPending,
            { bsp: bsp, sdr: sdr, gst: gst, total: agreementVal },
            cancellationCharge,
            waveOff
          )
            .then((cancelresp) => {
              updateCancelRequestsForLeadAcceptance(resp[0].cancelUnitRequestId)
                .then((leadAccpetance) => {
                  console.log({ leadAccpetance });
                })
                .catch((err) => {
                  console.log(err);
                });
              console.log(cancelresp);
              updateLeadAllStatus(
                cancelresp.data[0].leadId,
                `Cancellation Done`
              )
                .then(async (updateLeadStatus) => {
                  updateAllotmentPaymentStatus(
                    cancelresp.data[0].allotmentPaymentId,
                    "Cancelled"
                  ).then((cancelresp1) => { });
                  updateAllotmentUnitCost(
                    resp[0].cancelUnitRequestId,
                    updatedPriceValues
                  )
                    .then((CancelUnitRequestsResp) => {
                      console.log({ CancelUnitRequestsResp });
                    })
                    .catch((err) => {
                      console.log(
                        "err in updateAllotmentUnitCostInCancellation",
                        err
                      );
                    });
                  // ! update token status also => make token available
                  // ??Not for preselect
                  // ??Discussion Pending
                  if (selectedAllotment.pricingType === "preselect") {
                    await supabase
                      .from("EventTokenLeadRelations")
                      .update({ status: "expired" })
                      .eq("paymentId", selectedAllotment.paymentId)
                      .then((cancelresp3) => { });
                  }
                  // supabase
                  //   .from("InventoryStatus")
                  //   .select("*")
                  //   .eq("status", "Available")
                  //   .then((statusRes) => {
                  //     const availableStatus = statusRes.data[0].inventoryStatusId;
                  // ! update inventory prices

                  // !!Single Unit
                  // ??In Inventory table leadId===null and Inventory Status =Available by passing Availble status id
                  if (selectedAllotment.unitId !== null) {
                    // updateInventorForCancelUnit("51c40f6a-176d-4ef9-a2a7-a2c0569da025", cancelresp.data[0].allotmentPaymentId.unitId.unitId)
                    updateInventorStatusWiseForCancelUnitForLeads(
                      selectedAllotment.unitId,
                      selectedAllotment
                    )
                      .then((updateInventoryRes) => {
                        console.log(updateInventoryRes);
                        let obj = {
                          status: "Cancelled",
                          last_updated_at: new Date().getTime(),
                        };
                        updateAllotmentPayment(
                          obj,
                          selectedAllotment.allotmentPaymentId
                        )
                          .then((updateAllotmentPaymentRes) => {
                            console.log({ updateAllotmentPaymentRes });
                            let InventoryLogObj = {
                              userId: loggedInUser?.userId,
                              leadId: selectedAllotment.leadId,
                              status: "Available",
                              unitId: selectedAllotment.unitId,
                            };
                            insertInventoryLogs(InventoryLogObj)
                              .then((insertInventoryLogsRes) => {
                                console.log({ insertInventoryLogsRes });
                                let leadlogobj = {
                                  allotmentPaymentId: selectedAllotment.allotmentPaymentId,
                                  leadId: selectedAllotment.leadId,
                                  leadStatus: `Cancellation Done`,
                                  message: `Cancellation Done for ${selectedAllotment.unitData.wingId?.wingName}-${selectedAllotment.unitData?.unitNo},${selectedAllotment.unitData.projectId?.projectName} done by ${loggedInUser?.name}(${loggedInUser?.roleId?.title})`,
                                };
                                leadlogobj.message = leadlogobj.message + `. ${buttonValue === "acceptWithoutRefund" && "Hold Refund"}, Cancellation Charges ₹${numberWithCommas(cancelCharge ?? 0)}, Waived charges ₹${numberWithCommas(obj?.waivedOffCancellationCharges ?? 0)}, Total Cancellation Charges ₹${numberWithCommas(obj?.newCancellationCharges ?? 0)}${waveOff ? ", WaivedOff Reason:" + obj?.waivedOffReason : ""}.`
                                addLeadLogs(leadlogobj)
                                  .then((leadLog) => {
                                    console.log(leadLog);
                                  })
                                  .catch((err) => {
                                    console.log("leadlog", err);
                                  });
                                if (buttonValue === "acceptWithRefund") {
                                  let body = {
                                    mode: "Allotment",
                                    allotmentPaymentId:
                                      selectedAllotment?.allotmentPaymentId,
                                    cancellationCharges:
                                      updatedPriceValues?.cancellationCharges,
                                    refund: true,
                                  };
                                  console.log({ body });
                                  presentLoader();
                                  refundTokenPayment(body)
                                    .then((respRefundTokenPay) => {
                                      setConfirmationAlertModal(false);
                                      console.log({ respRefundTokenPay });
                                      if (
                                        respRefundTokenPay?.data?.success[0]
                                          ?.status === "success"
                                      ) {
                                        //Remove Parking Selection
                                        if (selectedParking?.length > 0) {
                                          removeSelectedParking().then(() => {
                                            // !!All Updates are Handled by Siddarth's refundtokenpayment api
                                            successTost(
                                              "Cancellation done successfully and Allotment refund initiated successfully"
                                            );
                                            setOpenCancelUnitConfirmationModal(
                                              false
                                            );
                                            dismissLoader();
                                            setConfirmationAlertModal(false);
                                            closeModal();
                                            returnRes(true);
                                          })
                                            .catch((error) => {
                                              console.error("Error occurred:", error);
                                              error("Error while deleting associated parking!");
                                              dismissLoader();
                                              closeModal();
                                            });
                                        }
                                      } else {
                                        // !!All Updates are Handled by Siddarth's refundtokenpayment api
                                        successTost(
                                          "Cancellation done successfully and Allotment refund initiated successfully"
                                        );
                                        setOpenCancelUnitConfirmationModal(
                                          false
                                        );
                                        dismissLoader();
                                        setConfirmationAlertModal(false);
                                        closeModal();
                                        returnRes(true);
                                      }
                                    })
                                    .catch((errInRefundPay) => {
                                      dismissLoader();
                                      console.log({ errInRefundPay });
                                      errorTost(errInRefundPay.message);
                                      closeModal();
                                      setConfirmationAlertModal(false);
                                      returnRes(true);
                                    });
                                } else {
                                  let body = {
                                    mode: "Allotment",
                                    allotmentPaymentId:
                                      selectedAllotment?.allotmentPaymentId,
                                    cancellationCharges:
                                      updatedPriceValues?.cancellationCharges,
                                    refund: false,
                                  };
                                  console.log({ body });
                                  presentLoader();
                                  refundTokenPayment(body)
                                    .then((respRefundTokenPay) => {
                                      setConfirmationAlertModal(false);
                                      console.log({ respRefundTokenPay });
                                      if (
                                        respRefundTokenPay?.data?.success[0]
                                          ?.status === "success"
                                      ) {
                                        if (selectedParking?.length > 0) {
                                          removeSelectedParking().then(() => {
                                            // !!All Updates are Handled by Siddarth's refundtokenpayment api
                                            successTost(
                                              "Cancellation done successfully and Allotment refund initiated successfully"
                                            );
                                            setOpenCancelUnitConfirmationModal(
                                              false
                                            );
                                            dismissLoader();
                                            setConfirmationAlertModal(false);
                                            closeModal();
                                            returnRes(true);
                                          })
                                            .catch((error) => {
                                              console.error("Error occurred:", error);
                                              error("Error while deleting associated parking!");
                                              dismissLoader();
                                              closeModal();
                                            });
                                        } else {
                                          // !!All Updates are Handled by Siddarth's refundtokenpayment api
                                          successTost(
                                            "Cancellation done successfully and Allotment refund initiated successfully"
                                          );
                                          setOpenCancelUnitConfirmationModal(
                                            false
                                          );
                                          dismissLoader();
                                          setConfirmationAlertModal(false);
                                          closeModal();
                                          returnRes(true);
                                        }
                                      } else {
                                        dismissLoader();
                                        errorTost(
                                          '"Cancellation done successfully but error while refunding.' +
                                          respRefundTokenPay?.data?.failed[0]
                                            ?.reason
                                        );
                                        closeModal();
                                        setOpenCancelUnitConfirmationModal(
                                          false
                                        );
                                        setConfirmationAlertModal(false);
                                        returnRes(true);
                                      }
                                    })
                                    .catch((errInRefundPay) => {
                                      dismissLoader();
                                      console.log({ errInRefundPay });
                                      errorTost(errInRefundPay.message);
                                      closeModal();
                                      setConfirmationAlertModal(false);
                                      setOpenCancelUnitConfirmationModal(false);
                                      returnRes(true);
                                    });
                                  // returnRes(true);
                                  // successTost("Cancellation done successfully!");
                                  // handleClose();
                                  // dismissLoader();
                                  // setConfirmationAlertModal(false);
                                  // console.log("Second Hii");
                                  // setOpenCancelUnitConfirmationModal(false);
                                }
                              })
                              .catch((err) => {
                                console.log(
                                  "err while inserting into inventory log",
                                  err
                                );
                              });
                          })
                          .catch((err) => {
                            console.log(
                              "err while updating allotmentPayment table"
                            );
                          });
                      })
                      .catch((err) => {
                        console.log(err);
                      });
                  } else {
                    // !!Merged Units
                    // updateAllotmentUnitCost(cancelresp.data[0].allotmentPaymentId?.inventoryMergedId?.unit1Id.unitId,values).then((cancelresp.data)=>{
                    //   console.log(cancelresp.data);
                    // });
                    // updateAllotmentUnitCost(cancelresp.data[0].allotmentPaymentId?.inventoryMergedId?.unit2Id.unitId,values).then((cancelresp.data)=>{
                    //   console.log(cancelresp.data);
                    // });
                    updateInventorForCancelUnit(
                      selectedAllotment.inventoryMergedId?.unit1Id.unitId,
                      bsp,
                      gst,
                      sdr,
                      agreementVal
                    )
                      .then((updateInventoryRes) => {
                        console.log(updateInventoryRes);
                        let obj = {
                          status: "Cancelled",
                          last_updated_at: new Date().getTime(),
                        };
                        updateAllotmentPayment(
                          obj,
                          selectedAllotment.allotmentPaymentId
                        )
                          .then((updateAllotmentPaymentRes) => {
                            console.log({ updateAllotmentPaymentRes });
                            let InventoryLogObj = {
                              userId: loggedInUser?.userId,
                              leadId: selectedAllotment.leadId,
                              status: "Available",
                              unitId:
                                selectedAllotment.inventoryMergedId?.unit1Id
                                  .unitId,
                            };
                            insertInventoryLogs(InventoryLogObj)
                              .then((insertInventoryLogsRes) => {
                                console.log({ insertInventoryLogsRes });
                              })
                              .catch((err) => {
                                console.log(
                                  "err while inserting into inventory log",
                                  err
                                );
                              });
                          })
                          .catch((err) => {
                            console.log(
                              "err while updating allotmentPayment table"
                            );
                          });
                      })
                      .catch((err) => {
                        console.log(err);
                      });
                    updateInventorForCancelUnit(
                      selectedAllotment.inventoryMergedId?.unit2Id.unitId,
                      bsp,
                      gst,
                      sdr,
                      agreementVal
                    )
                      .then((updateInventoryRes) => {
                        console.log(updateInventoryRes);
                        let obj = {
                          status: "Cancelled",
                          last_updated_at: new Date().getTime(),
                        };
                        updateAllotmentPayment(
                          obj,
                          selectedAllotment.allotmentPaymentId
                        )
                          .then((updateAllotmentPaymentRes) => {
                            console.log({ updateAllotmentPaymentRes });
                            let InventoryLogObj = {
                              userId: loggedInUser?.userId,
                              leadId: selectedAllotment.leadId,
                              status: "Available",
                              unitId:
                                selectedAllotment.inventoryMergedId?.unit2Id
                                  .unitId,
                            };
                            insertInventoryLogs(InventoryLogObj)
                              .then((insertInventoryLogsRes) => {
                                console.log({ insertInventoryLogsRes });
                              })
                              .catch((err) => {
                                console.log(
                                  "err while inserting into inventory log",
                                  err
                                );
                              });
                            if (selectedParking?.length > 0) {
                              removeSelectedParking().then(() => {
                                dismissLoader();
                                console.log("else part");
                                setConfirmationAlertModal(false);
                                successTost("Cancellation done successfully!");
                                refreshPageAfterSuccess();
                              })
                                .catch((error) => {
                                  console.error("Error occurred:", error);
                                  error("Error while deleting associated parking!");
                                  dismissLoader();
                                  closeModal();
                                });
                            } else {
                              dismissLoader();
                              console.log("else part");
                              setConfirmationAlertModal(false);
                              successTost("Cancellation done successfully!");
                              refreshPageAfterSuccess();
                            }
                          })
                          .catch((err) => {
                            console.log(
                              "err while updating allotmentPayment table"
                            );
                          });
                      })
                      .catch((err) => {
                        console.log(err);
                      });
                    let leadlogobj = {
                      allotmentPaymentId: selectedAllotment.allotmentPaymentId,
                      leadId: selectedAllotment.leadId,
                      leadStatus: `Cancellation Done`,
                      message: `Cancellation Done for ${selectedAllotment.inventoryMergedId?.unit1Id?.unitNo}-${selectedAllotment.inventoryMergedId?.unit2Id?.unitNo},${selectedAllotment.inventoryMergedId?.unit2Id?.projectId?.projectName} done by ${loggedInUser?.name}(${loggedInUser?.roleId?.title})`,
                    };
                    leadlogobj.message = leadlogobj.message + `. ${buttonValue === "acceptWithoutRefund" && "Hold Refund"}, Cancellation Charges ₹${numberWithCommas(cancelCharge ?? 0)}, Waived charges ₹${numberWithCommas(obj?.waivedOffCancellationCharges ?? 0)}, Total Cancellation Charges ₹${numberWithCommas(obj?.newCancellationCharges ?? 0)}${waveOff ? ", WaivedOff Reason:" + obj?.waivedOffReason : ""}.`
                    addLeadLogs(leadlogobj)
                      .then((leadLog) => {
                        console.log(leadLog);
                      })
                      .catch((err) => {
                        console.log("leadlog", err);
                      });
                  }
                })
                .catch((err) => {
                  console.log(err, "err while changing unit");
                });
            })
            .catch((err) => {
              console.log(err);
              dismissLoader();
              setConfirmLoading(false);
              errorTost("Error while confirming");
            });
        }
      }).catch((err) => {
        console.log("err in cancelAllotedUnit", err);
        dismissLoader();
        setConfirmLoading(false);
        errorTost(err?.message || "Error while cancelling unit, please try again!");
      });
    } else {
      // ??Not preSelect Allotment
      let requestPending = {
        roleId: loggedInUser.roleId.roleId,
        parentId: loggedInUser.roleId.level === 1 ? null : loggedInUser.userId,
      };
      cancelAllotedUnit(
        loggedInUser.userId,
        ownedUnitData.allotmentPaymentId,
        cancelUnitData.description,
        "Pending",
        ownedUnitData.unitId,
        requestPending,
        data.leadId,
        "Pending",
        resp?.data[0]?.leadstatus,
        cancellationCharge,
        waveOff,
        obj
      ).then((cancelresp1) => {
        if (loggedInUser.parentId) {
          //  ! loggedInUser is not superadmin

          getUserByUserId(loggedInUser.parentId.userId).then((userResp) => {
            updateLeadAllStatus(
              data?.leadId,
              `Cancellation Confirmation Pending by ${userResp?.data.name}`
            )
              .then((updateLeadStatus) => {
                let obj = {
                  leadId: data?.leadId,
                  leadStatus: `Cancellation Confirmation Pending by ${userResp?.data.name}`,
                  message: `Cancellation request for ${ownedUnitData.projectName}, ${ownedUnitData.unitData.wingId.wingName}, ${ownedUnitData.unitData.unitNo} has been raised by ${loggedInUser?.name}(${loggedInUser?.roleId?.title}).Cancellation Confirmation Pending by ${userResp?.data.name}.Reason for ${cancelUnitData.description}`,
                };
                addLeadLogs(obj)
                  .then((leadLog) => {
                    console.log(leadLog);
                  })
                  .catch((err) => {
                    console.log("leadlog", err);
                  });
                updateAllotmentPaymentStatus(
                  ownedUnitData.allotmentPaymentId,
                  "Cancellation Requested"
                ).then((resp) => { });
                console.log(updateLeadStatus);
              })
              .catch((err) => {
                console.log(err, "err while changing unit");
              });
            console.log(cancelresp1);
            setConfirmLoading(false);
            closeModal();
            returnRes(true);
          });
        } else {
          presentLoader();
          setOpenCancelUnitConfirmationModal(false);
          let bsp =
            updatedPriceValues.bsp ||
            (selectedAllotment.unitCost.bsp
              ? selectedAllotment.unitCost.bsp
              : null);
          let gst =
            updatedPriceValues.gst ||
            (selectedAllotment.unitCost.gst
              ? selectedAllotment.unitCost.gst
              : null);
          let sdr =
            updatedPriceValues.sdr ||
            (selectedAllotment.unitCost.sdr
              ? selectedAllotment.unitCost.sdr
              : null);
          let agreementVal =
            updatedPriceValues.total ||
            (selectedAllotment.unitCost.total
              ? selectedAllotment.unitCost.total
              : null);
          // ! loggedInUser is superadmin
          updateCancelRequests(
            cancelresp1?.[0].cancelUnitRequestId,
            "Accepted",
            requestPending,
            { bsp: bsp, gst: gst, sdr: sdr, total: agreementVal },
            cancellationCharge,
            waveOff
          )
            .then((cancelresp) => {
              updateCancelRequestsForLeadAcceptance(
                cancelresp1[0].cancelUnitRequestId
              )
                .then((leadAccpetance) => {
                  console.log({ leadAccpetance });
                })
                .catch((err) => {
                  console.log(err);
                  dismissLoader();
                });
              console.log(cancelresp);
              updateLeadAllStatus(
                cancelresp.data[0].leadId,
                `Cancellation Done`
              )
                .then((updateLeadStatus) => {
                  updateAllotmentPaymentStatus(
                    cancelresp.data[0].allotmentPaymentId,
                    "Cancelled"
                  ).then((cancelresp1) => { });
                  updateAllotmentUnitCost(
                    cancelresp1[0].cancelUnitRequestId,
                    updatedPriceValues
                  )
                    .then((CancelUnitRequestsResp) => {
                      console.log(CancelUnitRequestsResp);
                    })
                    .catch((err) => {
                      dismissLoader();
                      console.log(
                        "err in updateAllotmentUnitCostInCancellation",
                        err
                      );
                    });
                  // ! update token status also => make token available
                  if (selectedAllotment.pricingType === "event") {
                    supabase
                      .from("EventTokenLeadRelations")
                      .select("*")
                      .eq("paymentId", selectedAllotment.paymentId)
                      .then((statusResp) => {
                        console.log({ statusResp });
                        // !!If token status is adjusted we don't  want to update token status to active
                        if (statusResp.data[0].status === "alloted") {
                          supabase
                            .from("EventTokenLeadRelations")
                            .update({ status: "active" })
                            .eq("paymentId", selectedAllotment.paymentId)
                            .then((cancelresp3) => { });
                        }
                      });
                  }
                  // supabase
                  //   .from("InventoryStatus")
                  //   .select("*")
                  //   .eq("status", "Available")
                  //   .then((statusRes) => {
                  //     const availableStatus = statusRes.data[0].inventoryStatusId;
                  // ! update inventory prices

                  // !!Single Unit
                  // ??In Inventory table leadId===null and Inventory Status =Available by passing Availble status id
                  if (selectedAllotment.unitId !== null) {
                    // updateInventorForCancelUnit("51c40f6a-176d-4ef9-a2a7-a2c0569da025", cancelresp.data[0].allotmentPaymentId.unitId.unitId)
                    updateInventorForCancelUnit(
                      selectedAllotment.unitId,
                      0,
                      0,
                      0,
                      0
                    )
                      .then((updateInventoryRes) => {
                        console.log(updateInventoryRes);
                        let obj = {
                          status: "Cancelled",
                          last_updated_at: new Date().getTime(),
                        };
                        updateAllotmentPayment(
                          obj,
                          selectedAllotment.allotmentPaymentId
                        )
                          .then((updateAllotmentPaymentRes) => {
                            console.log({ updateAllotmentPaymentRes });
                            let InventoryLogObj = {
                              userId: loggedInUser?.userId,
                              leadId: selectedAllotment.leadId,
                              status: "Available",
                              unitId: selectedAllotment.unitId,
                            };
                            insertInventoryLogs(InventoryLogObj)
                              .then((insertInventoryLogsRes) => {
                                console.log({ insertInventoryLogsRes });
                                let leadlogobj = {
                                  allotmentPaymentId: selectedAllotment.allotmentPaymentId,
                                  leadId: selectedAllotment.leadId,
                                  leadStatus: `Cancellation Done`,
                                  message: `Cancellation Done for ${selectedAllotment.unitData.wingId?.wingName}-${selectedAllotment.unitData?.unitNo},${selectedAllotment.unitData.projectId?.projectName} done by ${loggedInUser?.name}(${loggedInUser?.roleId?.title})`,
                                };
                                leadlogobj.message = leadlogobj.message + `. ${buttonValue === "acceptWithoutRefund" && "Hold Refund"}, Cancellation Charges ₹${numberWithCommas(cancelCharge ?? 0)}, Waived charges ₹${numberWithCommas(obj?.waivedOffCancellationCharges ?? 0)}, Total Cancellation Charges ₹${numberWithCommas(obj?.newCancellationCharges ?? 0)}${waveOff ? ", WaivedOff Reason:" + obj?.waivedOffReason : ""}.`
                                addLeadLogs(leadlogobj)
                                  .then((leadLog) => {
                                    console.log(leadLog);
                                  })
                                  .catch((err) => {
                                    console.log("leadlog", err);
                                  });

                                if (buttonValue === "acceptWithRefund") {
                                  let body = {
                                    mode: "Allotment",
                                    allotmentPaymentId:
                                      selectedAllotment?.allotmentPaymentId,
                                    cancellationCharges:
                                      updatedPriceValues?.cancellationCharges,
                                    // cancellationCharges:5000,
                                    refund: true,
                                  };
                                  console.log({ body });

                                  refundTokenPayment(body)
                                    .then((respRefundTokenPay) => {
                                      setConfirmationAlertModal(false);
                                      console.log({ respRefundTokenPay });
                                      if (
                                        respRefundTokenPay?.data?.success[0]
                                          ?.status === "success"
                                      ) {
                                        if (selectedParking?.length > 0) {
                                          removeSelectedParking().then(() => {
                                            //SUCCESS
                                            // !!All Updates are Handled by Siddarth's refundtokenpayment api
                                            successTost(
                                              "Cancellation done successfully and Allotment refund initiated successfully"
                                            );

                                            dismissLoader();
                                            closeModal();
                                            // setConfirmationAlertModal(false);
                                            returnRes(true);
                                          })
                                            .catch((error) => {
                                              console.error("Error occurred:", error);
                                              error("Error while deleting associated parking!");
                                              dismissLoader();
                                              closeModal();
                                            });
                                        } else {
                                          // !!All Updates are Handled by Siddarth's refundtokenpayment api
                                          successTost(
                                            "Cancellation done successfully and Allotment refund initiated successfully"
                                          );

                                          dismissLoader();
                                          closeModal();
                                          // setConfirmationAlertModal(false);
                                          returnRes(true);
                                        }
                                      } else {
                                        dismissLoader();
                                        errorTost(
                                          '"Cancellation done successfully but error while refunding.' +
                                          respRefundTokenPay?.data?.failed[0]
                                            ?.reason
                                        );
                                        closeModal();

                                        setConfirmationAlertModal(false);
                                        returnRes(true);
                                      }
                                    })
                                    .catch((errInRefundPay) => {
                                      dismissLoader();
                                      console.log({ errInRefundPay });
                                      errorTost(errInRefundPay.message);
                                      closeModal();
                                      setConfirmationAlertModal(false);
                                      returnRes(true);
                                    });
                                } else {
                                  let body = {
                                    mode: "Allotment",
                                    allotmentPaymentId:
                                      selectedAllotment?.allotmentPaymentId,
                                    cancellationCharges:
                                      updatedPriceValues?.cancellationCharges,
                                    //  cancellationCharges: 5000,
                                    refund: false,
                                  };
                                  console.log({ body });
                                  presentLoader();
                                  refundTokenPayment(body)
                                    .then((respRefundTokenPay) => {
                                      setConfirmationAlertModal(false);
                                      console.log({ respRefundTokenPay });
                                      if (
                                        respRefundTokenPay?.data?.success[0]
                                          ?.status === "success"
                                      ) {
                                        if (selectedParking?.length > 0) {
                                          removeSelectedParking().then(() => {
                                            //SUCCESS
                                            // !!All Updates are Handled by Siddarth's refundtokenpayment api
                                            successTost(
                                              "Cancellation done successfully"
                                            );
                                            setOpenCancelUnitConfirmationModal(
                                              false
                                            );
                                            dismissLoader();
                                            setConfirmationAlertModal(false);
                                            closeModal();
                                            returnRes(true);
                                          })
                                            .catch((error) => {
                                              console.error("Error occurred:", error);
                                              error("Error while deleting associated parking!");
                                              dismissLoader();
                                              closeModal();
                                            });
                                        } else {
                                          // !!All Updates are Handled by Siddarth's refundtokenpayment api
                                          successTost(
                                            "Cancellation done successfully"
                                          );
                                          setOpenCancelUnitConfirmationModal(
                                            false
                                          );
                                          dismissLoader();
                                          setConfirmationAlertModal(false);
                                          closeModal();
                                          returnRes(true);
                                        }
                                      } else {
                                        dismissLoader();
                                        errorTost(
                                          "Cancellation done successfully but error while refunding." +
                                          respRefundTokenPay?.data?.failed[0]
                                            ?.reason
                                        );
                                        closeModal();
                                        setOpenCancelUnitConfirmationModal(
                                          false
                                        );
                                        setConfirmationAlertModal(false);
                                        returnRes(true);
                                      }
                                    })
                                    .catch((errInRefundPay) => {
                                      dismissLoader();
                                      console.log({ errInRefundPay });
                                      errorTost(errInRefundPay.message);
                                      closeModal();
                                      setConfirmationAlertModal(false);
                                      returnRes(true);
                                    });
                                  // returnRes(true);
                                  // dismissLoader();
                                  // successTost("Cancellation done successfully!");
                                  // handleClose();
                                  // setConfirmationAlertModal(false);
                                  // console.log("Second Hii");
                                  // setOpenCancelUnitConfirmationModal(false);
                                }

                                // // ! !Adding Refund Initiate option
                                // setOpenAlertBoxForCancellation(true);
                              })
                              .catch((err) => {
                                console.log(
                                  "err while inserting into inventory log",
                                  err
                                );
                              });
                          })
                          .catch((err) => {
                            console.log(
                              "err while updating allotmentPayment table"
                            );
                          });
                      })
                      .catch((err) => {
                        console.log(err);
                      });
                  }
                  // ??Not considering it now for merged unit
                  // else {
                  //   // !!Merged Units
                  //   // updateAllotmentUnitCost(cancelresp.data[0].allotmentPaymentId?.inventoryMergedId?.unit1Id.unitId,values).then((cancelresp.data)=>{
                  //   //   console.log(cancelresp.data);
                  //   // });
                  //   // updateAllotmentUnitCost(cancelresp.data[0].allotmentPaymentId?.inventoryMergedId?.unit2Id.unitId,values).then((cancelresp.data)=>{
                  //   //   console.log(cancelresp.data);
                  //   // });
                  //   updateInventorForCancelUnit(
                  //     selectedAllotment.inventoryMergedId?.unit1Id.unitId,
                  //     bsp,
                  //     gst,
                  //     sdr,
                  //     agreementVal
                  //   )
                  //     .then((updateInventoryRes) => {
                  //       console.log(updateInventoryRes);
                  //       let obj = {
                  //         status: "Cancelled",
                  //         last_updated_at:new Date().getTime()
                  //       };
                  //       updateAllotmentPayment(
                  //         obj,
                  //         selectedAllotment.allotmentPaymentId
                  //       )
                  //         .then((updateAllotmentPaymentRes) => {
                  //           console.log({ updateAllotmentPaymentRes });
                  //           let InventoryLogObj = {
                  //             userId: loggedInUser?.userId,
                  //             leadId: selectedAllotment.leadId,
                  //             status: "Available",
                  //             unitId:
                  //               selectedAllotment.inventoryMergedId?.unit1Id
                  //                 .unitId,
                  //           };
                  //           insertInventoryLogs(InventoryLogObj)
                  //             .then((insertInventoryLogsRes) => {
                  //               console.log({ insertInventoryLogsRes });
                  //             })
                  //             .catch((err) => {
                  //               console.log(
                  //                 "err while inserting into inventory log",
                  //                 err
                  //               );
                  //             });
                  //         })
                  //         .catch((err) => {
                  //           console.log(
                  //             "err while updating allotmentPayment table"
                  //           );
                  //         });
                  //     })
                  //     .catch((err) => {
                  //       console.log(err);
                  //     });
                  //   updateInventorForCancelUnit(
                  //     selectedAllotment.inventoryMergedId?.unit2Id.unitId,
                  //     bsp,
                  //     gst,
                  //     sdr,
                  //     agreementVal
                  //   )
                  //     .then((updateInventoryRes) => {
                  //       console.log(updateInventoryRes);
                  //       let obj = {
                  //         status: "Cancelled",
                  //         last_updated_at:new Date().getTime()
                  //       };
                  //       updateAllotmentPayment(
                  //         obj,
                  //         selectedAllotment.allotmentPaymentId
                  //       )
                  //         .then((updateAllotmentPaymentRes) => {
                  //           console.log({ updateAllotmentPaymentRes });
                  //           let InventoryLogObj = {
                  //             userId: loggedInUser?.userId,
                  //             leadId: selectedAllotment.leadId,
                  //             status: "Available",
                  //             unitId:
                  //               selectedAllotment.inventoryMergedId?.unit2Id
                  //                 .unitId,
                  //           };
                  //           insertInventoryLogs(InventoryLogObj)
                  //             .then((insertInventoryLogsRes) => {
                  //               console.log({ insertInventoryLogsRes });
                  //             })
                  //             .catch((err) => {
                  //               console.log(
                  //                 "err while inserting into inventory log",
                  //                 err
                  //               );
                  //             });
                  //           dismissLoader();
                  //           console.log("else part");
                  //           setConfirmationAlertModal(false);
                  //           successTost("Cancellation done successfully!");
                  //         })
                  //         .catch((err) => {
                  //           console.log(
                  //             "err while updating allotmentPayment table"
                  //           );
                  //         });
                  //     })
                  //     .catch((err) => {
                  //       console.log(err);
                  //     });
                  //   let leadlogobj = {
                  //     leadId: selectedAllotment.leadId,
                  //     leadStatus: `Cancellation Done`,
                  //     message: `Cancellation Done for ${selectedAllotment.inventoryMergedId?.unit1Id?.unitNo}-${selectedAllotment.inventoryMergedId?.unit2Id?.unitNo},${selectedAllotment.inventoryMergedId?.unit2Id?.projectId?.projectName} done by ${loggedInUser?.name}(${loggedInUser?.roleId?.title})`,
                  //   };
                  //   addLeadLogs(leadlogobj)
                  //     .then((leadLog) => {
                  //       console.log(leadLog);
                  //     })
                  //     .catch((err) => {
                  //       console.log("leadlog", err);
                  //     });
                  // }
                  // })
                })
                .catch((err) => {
                  console.log(err, "err while changing unit");
                });
            })
            .catch((err) => {
              console.log(err);
              dismissLoader();
              setConfirmLoading(false);
              errorTost("Error while confirming");
            });
        }
        // updateLeadAllStatus(data?.leadId, `Cancellation Confirmation Pending by ${data?.leadname}`)
        //   .then((updateLeadStatus) => {
        //     let obj = {
        //       leadId: data?.leadId,
        //       leadStatus: `Cancellation Confirmation Pending by ${data?.leadname}`,
        //       message: `Cancellation request for ${ownedUnitData.projectName}, ${ownedUnitData.unitData.wingId.wingName}, ${ownedUnitData.unitData.unitNo} has been raised.Cancellation Confirmation Pending by ${data?.leadname}.Reason for ${cancelUnitData.description}`
        //     }
        //     addLeadLogs(obj).then((leadLog) => { console.log(leadLog) }).catch((err) => { console.log('leadlog', err) })
        //     updateAllotmentPaymentStatus(ownedUnitData.allotmentPaymentId, 'Cancellation Requested').then((cancelresp2) => {
        //     });
        //     console.log(updateLeadStatus);
        //   })
        //   .catch((err) => {
        //     console.log(err, "err while changing unit");
        //   });
        // sendMailAndSms(
        //   data?.leademail,
        //   loggedInUser.roleId.level !== 1
        //     ? "Requested to Cancel Unit"
        //     : "Unit Cancellation successfull"
        // ).then((resp) => {
        //   if (resp.emailRes && resp.sms) {
        //     successTost(
        //       `Cancel unit request raised successfully.Email and sms sent successfully!`
        //       // `${data?.leadname}  has requested for Cancel unit successfully.Email and sms sent successfully`
        //     );
        //   } else if (resp.emailRes === false && resp.sms) {
        //     successTost(
        //       "Cancel unit request raised successfully! Sms to lead sent successfully!"
        //     );
        //     errorTost(
        //       `Error while sending email to lead!`
        //       // `${data?.leadname}  has requested for Cancel unit successfully.Sms sent successfully,error while sending email `
        //     );
        //   } else if (resp.emailRes && resp.sms === false) {
        //     successTost(
        //       "Cancel unit request raised successfully! Sms to lead sent successfully!"
        //     );
        //     errorTost(
        //       `Error while sending sms to lead!`
        //       // `${data?.leadname}  has requested for Cancel unit successfully.Email sent successfully,error while sending sms `
        //     );
        //   } else {
        //     successTost("Cancel unit request raised successfully!");
        //     errorTost(
        //       `Error while sending email and sms to lead!`
        //       // `${data?.leadname}  has requested for Cancel unit successfully.Error while sending Email and Sms`
        //     );
        //   }
        // });
        let obj = {
          action:
            loggedInUser.roleId.level !== 1
              ? `A cancellation request has been raised for Unit ${ownedUnitData?.unitData?.unitNo} in wing ${ownedUnitData?.unitData?.wingId?.wingName} of ${ownedUnitData?.projectName} by VJ SM ${loggedInUser.name}(${loggedInUser?.roleId?.title}) for ${data?.leadname}`
              : `Cancellation has been done for Unit ${ownedUnitData?.unitData?.unitNo} in wing ${ownedUnitData?.unitData?.wingId?.wingName} of ${ownedUnitData?.projectName} by VJ SM ${loggedInUser.name}(${loggedInUser?.roleId?.title})`,
          eventId: selectedAllotment?.eventId,
          cpId: data?.cpid,
          leadId: data?.leadId,
          userId: loggedInUser?.userId,
          allotmentPaymentId: ownedUnitData?.allotmentPaymentId,
        };
        if (data?.cpid !== null) {
          addLeadNotificationForCp(obj)
            .then((leadNotificationRes) => {
              console.log({ leadNotificationRes });
            })
            .catch((error) => {
              console.log(error);
            });
        }
        //  closeModal();
        // returnRes(true);
      }).catch((err) => {
        console.log("err in cancelAllotedUnit", err);
        dismissLoader();
        setConfirmLoading(false);
        errorTost(err?.message || "Error while cancelling unit, please try again!");
      });
    }
  }
  function releaseUnit(allotment) {
    console.log({ allotment });
    presentLoader();
    if (allotment.pricingType === "event") {
      supabase
        .from("EventTokenLeadRelations")
        .update({ status: "active", last_updated_at: Date.now() })
        .eq("paymentId", allotment.paymentId)
        .then((resp) => {
          supabase
            .from("LeadStatus")
            .update({
              status: "Checkpoint Two Cleared",
              last_updated_at: Date.now(),
            })
            .eq("leadId", allotment.leadId)
            .then((resp) => {
              let obj = {
                leadId: allotment.leadId,
                leadStatus: `Checkpoint Two Cleared`,
                message: `Unit Release for ${selectedAllotment?.unitData?.wingId?.wingName}-${selectedAllotment?.unitData?.unitNo},${selectedAllotment?.unitData?.projectId?.projectName} done by ${loggedInUser?.name}(${loggedInUser?.roleId?.title}) done by ${loggedInUser?.name}(${loggedInUser?.roleId?.title})`,
              };
              addLeadLogs(obj)
                .then((leadLog) => {
                  dismissLoader();
                  setConfirmationAlertModal(false);
                  closeModal();
                  console.log(leadLog);
                })
                .catch((err) => {
                  dismissLoader();
                  console.log("leadlog", err);
                });
              changeAllotmentStatus(allotment);
            });
        });
    } else {
      supabase
        .from("LeadStatus")
        .update({ status: "Site Visit Done" })
        .eq("leadId", allotment.leadId)
        .then((resp) => {
          let obj = {
            leadId: allotment.leadId,
            leadStatus: `Site Visit Done`,
            message: `Unit Release for ${selectedAllotment?.unitData?.wingId?.wingName}-${selectedAllotment?.unitData?.unitNo},${selectedAllotment?.unitData?.projectId?.projectName} done by ${loggedInUser?.name}(${loggedInUser?.roleId?.title})`,
          };
          addLeadLogs(obj)
            .then((leadLog) => {
              dismissLoader();
              closeModal();
              setConfirmationAlertModal(false);
              console.log(leadLog);
            })
            .catch((err) => {
              dismissLoader();
              console.log("leadlog", err);
            });
          changeAllotmentStatus(allotment);
        });
    }
  }
  function changeAllotmentStatus(allotment) {
    supabase
      .from("AllotmentPayment")
      .update({ status: "Released" })
      .eq("allotmentPaymentId", allotment.allotmentPaymentId)
      .then(async (resp) => {
        if (allotment.unitId) {
          let unit = await changeUnitStatus(allotment.unitId);
          returnRes(true);
          closeModal();
          dismissLoader();
        } else {
          let unit1 = await changeUnitStatus(
            allotment.inventoryMergedId.unit1Id
          );
          let unit2 = await changeUnitStatus(
            allotment.inventoryMergedId.unit2Id
          );
          returnRes(true);
          closeModal();
          dismissLoader();
        }
      });
  }
  function changeUnitStatus(unitId) {
    return new Promise((resolve, reject) => {
      supabase
        .from("Inventory")
        .select("*,inventoryStatusId(*)")
        .eq("unitId", unitId)
        .then((resp) => {
          if (
            resp.data[0].inventoryStatusId.status === "On Hold" ||
            resp.data[0].inventoryStatusId.status === "Payment Pending" ||
            resp.data[0].inventoryStatusId.status === "Preselected"
          ) {
            supabase
              .from("InventoryStatus")
              .select("*")
              .eq("status", "Available")
              .then((statusRes) => {
                supabase
                  .from("Inventory")
                  .update({
                    last_updated_at: new Date().getTime(),
                    inventoryStatusId: statusRes.data[0].inventoryStatusId,
                    unitHoldTime: null,
                    leadId: null,
                  })
                  .eq("unitId", unitId)
                  .then((r) => {
                    supabase
                      .from("InventoryLogs")
                      .insert({ unitId: unitId, status: "available" })
                      .then((r) => {
                        resolve(true);
                      });
                  });
              });
          }
        });
    });
  }
  function closeModal() {
    handleClose();
    setHelperText((pre) => {
      pre.projectName = "";
      pre.wingName = "";
      pre.floorNo = "";
      pre.unitNo = "";
      return { ...pre };
    });
  }

  function numberWithCommas(x) {
    return x?.toString().replace(/\B(?=(?:(\d\d)+(\d)(?!\d))+(?!\d))/g, ",");
  }

  return (
    <Modal
      open={open}
      onClose={(_, reason) => {
        if (reason !== "backdropClick") {
          closeModal();
        }
      }}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      sx={[
        {
          ".MuiBackdrop-root": {
            background: "rgba(52, 64, 84, 0.7)",
          },
        },
      ]}
      disableAutoFocus={true}
    >
      <Box className={cssClasses.modalWrapper}>
        <div className={cssClasses.wrapperHeader}>
          <span className={classes.closeIcon} onClick={closeModal} tabIndex={0}>
            <Close width={"1.2rem"} height={"1.2rem"} />
          </span>
          <div>Cancel Unit</div>
        </div>
        <div className={cssClasses.wrapperContent}>
          <div className={cssClasses.wrapperBlock}>
            <div className={cssClasses.blockLabel}>
              All Allotted Projects <span style={{ color: "red" }}> *</span>
            </div>
            <div style={{ width: "100%" }}>
              <DropDown
                list={uniqBy(projectNameList, "label")}
                selectedValue={cancelUnitData.projectName}
                // disable={selectedAllotmentPass ? true : false}
                onChangeSelect={(_value) => {
                  console.log(_value);
                  let selectedProject;
                  selectedProject = projectNameList.filter(
                    ({ value }) => _value === value
                  );
                  setCancellationPercentageMsg(null);
                  // !!find alloted data
                  console.log({ allotedData });
                  setAlreadyRaisedRequest(false);
                  //selected Project Data in selectedProject
                  const allotedWing = getProjectWiseWings(
                    allotedData,
                    uniqBy([...selectedProject], "label")[0]
                  );
                  console.log("allotedWing: ", allotedWing);
                  setWingNameList([...allotedWing]);
                  setCancelUnitData((pre) => {
                    pre.projectName = _value;
                    pre.wingName = "";
                    return { ...pre };
                  });
                  setHelperText((pre) => {
                    pre.projectName = "";
                    return { ...pre };
                  });
                }}
                placeHolder={"Select Project"}
                //style.color is placeHolder's color
                style={{
                  background: "#F2F4F7",
                  color: "rgb(102, 112, 133)",
                }}
                helperText={helperText.projectName}
              />
            </div>
          </div>
          <div className={cssClasses.wrapperBlock}>
            <div className={cssClasses.blockLabel}>
              Unit <span style={{ color: "red" }}> *</span>
            </div>
            <div style={{ width: "100%" }}>
              <DropDown
                list={wingNameList}
                selectedValue={cancelUnitData.wingName}
                // disable={selectedAllotmentPass ? true : false}
                onChangeSelect={(value) => {
                  console.log({ value });
                  setCancelUnitData((pre) => {
                    pre.wingName = value;
                    return { ...pre };
                  });
                  setHelperText((pre) => {
                    pre.wingName = "";
                    return { ...pre };
                  });
                  let selectedUnit;
                  selectedUnit = allotedData.filter(
                    ({ unitId }) => value === unitId
                  );
                  console.log({ selectedUnit });
                  setSelectedAllotment(selectedUnit[0]);
                  // if (
                  //   selectedUnit[0].status === "Cancellation Done" ||
                  //   selectedUnit[0].status === "Cancellation Requested" ||
                  //   selectedUnit[0].status === "Cancellation Pending" ||
                  //   selectedUnit[0].status === "Cancellation Not Done" ||
                  //   selectedUnit[0].status === "Cancelled" ||
                  //   selectedUnit[0].status === "Change Requested" ||
                  //   selectedUnit[0].status === "Released" ||
                  //   selectedUnit[0].status === "Cancellation Rejected" ||
                  //   selectedUnit[0].status.includes("Refund")
                  // ) {
                  if (
                    selectedUnit[0].status === "Cancellation Done" ||
                    selectedUnit[0].status === "Cancellation Requested" ||
                    selectedUnit[0].status === "Cancellation Pending" ||
                    selectedUnit[0].status === "Cancelled" ||
                    selectedUnit[0].status === "Change Requested" ||
                    selectedUnit[0].status === "Released" ||
                    selectedUnit[0].status.includes("Refund") ||
                    // (selectedUnit[0].CRM && 
                    (selectedUnit[0]["100B2bRes"] || selectedUnit[0]?.gstB2bRes || selectedUnit[0]?.SdrB2bRes)
                  ) {
                    setAlreadyRaisedRequest(true);
                  } else {
                    setAlreadyRaisedRequest(false);
                  }
                  setOwnedData((pre) => {
                    pre.bsp = selectedUnit[0]?.unitCost?.bsp;
                    pre.allotmentStatus = selectedUnit[0].status;
                    pre.projectName =
                      selectedUnit[0].unitData?.projectId?.projectName;
                    pre.allotmentPaymentId = selectedUnit[0].allotmentPaymentId;
                    pre.unitId = selectedUnit[0].unitId;
                    pre.unitData = selectedUnit[0].unitData;
                    pre.inventoryMergedId =
                      selectedUnit[0].unitData.inventoryMergedId;
                    pre.CRM = selectedUnit[0].CRM;
                    pre.hundredB2bRes = selectedUnit[0]?.["100B2bRes"]
                    pre.gstB2bRes = selectedUnit[0]?.gstB2bRes
                    pre.SdrB2bRes = selectedUnit[0]?.SdrB2bRes

                    return { ...pre };
                  });
                  // getAllInventory(selectedProject[0].projectId);
                }}
                // toFindallotmentPaymentId

                placeHolder={"Select Unit"}
                //style.color is placeHolder's color
                style={{
                  background: "#F2F4F7",
                  color: "rgb(102, 112, 133)",
                }}
                helperText={helperText.wingName}
              />
            </div>
          </div>

          <div
            className={cssClasses.wrapperBlock}
            style={{ width: "100%", textAlign: "left" }}
          >
            <div
              className={cssClasses.blockLabel}
              style={{ width: "100%", textAlign: "left" }}
            >
              Reason:
              <span style={{ color: "red" }}> *</span>
              <div style={{ width: "100%", marginTop: "1rem" }}>
                <TextField
                  maxRows={4}
                  value={cancelUnitData.description}
                  onChange={(e) => {
                    e.target.value = e.target.value.trimStart();
                    if (e.target.value.length <= 200) {
                      setCancelUnitData((pre) => {
                        pre.description = e.target.value;
                        return { ...pre };
                      });
                    }
                    if (e.target.value.length === 0) {
                      setHelperText((pre) => {
                        pre.description = "Please enter description";
                        return { ...pre };
                      });
                    } else {
                      setHelperText((pre) => {
                        pre.description = "";
                        return { ...pre };
                      });
                    }
                  }}
                  placeholder={"Type..."}
                  helperText={helperText.description}
                  error={helperText.description !== ""}
                  className={classes.TextFieldStyle}
                  InputProps={{
                    className: classes.inputStyle,
                  }}
                  inputProps={{ min: 0 }}
                  FormHelperTextProps={{ className: classes.helperText }}
                  multiline
                />
              </div>
            </div>
          </div>
          {/* Show  Message for cancellation % applied*/}
          {/* { selectedAllotment?.status==='Payment Complete'&&( */}
          {!alreadyRaisedRequest && (
            <div
              className={cssClasses.wrapperBlock}
              style={{ width: "100%", textAlign: "left" }}
            >
              <div
                className={cssClasses.blockLabel}
                style={{ width: "100%", textAlign: "left", color: "red" }}
              >
                {cancellationPercentageMsg}
              </div>
            </div>
          )}
          {/* )} */}
          {/* Error Message Screen */}
          {/* cancellationPercentageMsg */}
          <div className={cssClasses.wrapperBlock}>
            {alreadyRaisedRequest && (
              <div style={{ width: "100%", marginTop: "1rem" }}>
                <div
                  className={cssClasses.blockLabel}
                  style={{ width: "100%", textAlign: "left", color: "red" }}
                >
                  {ownedUnitData?.projectName},{" "}
                  {/* {ownedUnitData?.unitData?.wingId?.wingName} -{" "} */}
                  {ownedUnitData?.unitData?.wingId?.displayName ? ownedUnitData?.unitData?.wingId?.displayName : ownedUnitData?.unitData?.wingId?.wingName} -{" "}
                  {ownedUnitData?.unitData?.unitNo} cannot be Cancelled
                  {((ownedUnitData?.hundredB2bRes || ownedUnitData?.gstB2bRes || ownedUnitData?.SdrB2bRes)) ? '. Contact your CRM!' : ' as it is ' + ownedUnitData?.allotmentStatus}
                </div>
              </div>
            )}
          </div>
        </div>

        <div className={cssClasses.wrapperFooter}>
          <div>
            <Button
              style={{
                color: "#344054",
                backgroundColor: "#ffffff",
                fontSize: "1.6rem",
                lineHeight: "2.4rem",
              }}
              btnName={"Cancel"}
              clicked={closeModal}
            />
          </div>
          <div>
            <Button
              style={{
                color: "#ffffff",
                backgroundColor: "#155EEF",
                fontSize: "1.6rem",
                lineHeight: "2.4rem",
              }}
              disable={
                alreadyRaisedRequest || selectedAllotment?.bookingId !== null || isUnitNotCancelled || isDraftSkipOrCreated
              }
              btnName={
                selectedAllotment?.paidAmount > 0
                  ? loggedInUser.roleId.level === 1
                    ? "Cancel Unit"
                    : "Raise a request"
                  : "Release"
              }
              clicked={() => {
                getSelectedParkingNumbers();
                save();
              }}
            />
          </div>

          {confirmationAlertModal && (
            <ConfirmationAlert
              open={confirmationAlertModal}
              close={() => {
                setConfirmationAlertModal(false);
              }}
              title={confirmationTitle}
              subTitle={confirmationSubTitle}
              buttonTitle={"Cancel"}
              returnRespButton={"Confirm"}
              confirm={responseValue}
              disableConfirm={disableConfirm.current}
              isLoading={confirmLoading}
            />
          )}
          {openCancelUnitConfirmationModal && (
            <CancelUnitConfirmation
              open={openCancelUnitConfirmationModal}
              handleClose={() => {
                setOpenCancelUnitConfirmationModal(false);
              }}
              returnRes={(values, buttonValue, waiveOff, cancelCharge, obj) => {
                disableConfirm.current = true;
                setConfirmLoading(true);
                checkCancellations(values, buttonValue, waiveOff, cancelCharge, obj).catch((err) => {
                  console.log("err in checkCancellations", err);
                  dismissLoader();
                  setConfirmLoading(false);
                  errorTost(err?.message || "Error while cancelling unit, please try again!");
                });
              }}
              data={selectedAllotment}
              leadData={data}
            />
          )}
          {openAlertBoxForCancellation && (
            <ConfirmationAlert
              hideCloseIcon={true}
              confirm={(e) => {
                console.log(e);
                if (e === "confirmed") {
                  console.log({ selectedAllotment });
                  let body = {
                    mode: "Allotment",
                    allotmentPaymentId: selectedAllotment?.allotmentPaymentId,
                    cancellationCharges:
                      cancellationCharges?.cancellationCharges,
                  };
                  console.log({ body });
                  presentLoader();
                  refundTokenPayment(body)
                    .then((respRefundTokenPay) => {
                      setConfirmationAlertModal(false);
                      console.log({ respRefundTokenPay });
                      if (
                        respRefundTokenPay?.data?.success[0]?.status ===
                        "success"
                      ) {
                        // !!All Updates are Handled by Siddarth's refundtokenpayment api
                        successTost("Allotment refund initiated successfully");
                        dismissLoader();
                        closeModal();
                        setConfirmationAlertModal(false);
                        returnRes(true);
                      } else {
                        dismissLoader();
                        errorTost(respRefundTokenPay?.data?.failed[0]?.reason);
                        closeModal();
                        setConfirmationAlertModal(false);
                        returnRes(true);
                      }
                    })
                    .catch((errInRefundPay) => {
                      dismissLoader();
                      console.log({ errInRefundPay });
                      errorTost(errInRefundPay.message);
                      closeModal();
                      setConfirmationAlertModal(false);
                      returnRes(true);
                    });
                } else if ("rejected") {
                  setConfirmationAlertModal(false);
                  closeModal();
                  returnRes(true);
                }
              }}
              buttonTitle={"No"}
              returnRespButton={"Yes"}
              close={() => setOpenAlertBoxForCancellation(false)}
              title={"Info"}
              subTitle={`Do you want to Initiate Refund?`}
              open={openAlertBoxForCancellation}
            />
          )}
        </div>
      </Box>
    </Modal>
  );
}
